// Main reference for the flyouts. A category value starting with "!" is not actually
// refined but triggers a refinement for all the other related categories
export default {
  litGuideReference: [
    {
      label: "All Lit Guides",
      value: "!Lit Guide"
    },
    {
      label: "Titles",
      value: "Lit Guide > Lit Guide"
    },
    {
      label: "Themes",
      value: "Lit Guide > Theme"
    },
    {
      label: "Symbols",
      value: "Lit Guide > Symbol"
    },
    {
      label: "Characters",
      value: "Lit Guide > Character"
    },
    {
      label: "Terms",
      value: "Lit Guide > Term"
    },
    {
      label: "Quotes",
      value: "Lit Guide > Quotes"
    },
    {
      label: "Summary & Analysis",
      value: "Lit Guide > Summary & Analysis"
    },
    {
      label: "Quizzes",
      value: "Lit Guide > Quiz"
    },
    {
      label: "Literary Devices",
      value: "Lit Guide > Lit Device"
    }
  ],
  litTermReference: [
    {
      label: "All Lit Terms",
      value: "Lit Term > Lit Term"
    }
  ],
  mythologyReference: [
    {
      label: "All Mythology",
      value: "!Mythology"
    },
    {
      label: "Other",
      value: "Mythology > <n/a>"
    }
  ],
  playDramaReference: [
    {
      label: "All Plays/Drama",
      value: "!Play or Drama"
    },
    {
      label: "Musicals",
      value: "Play or Drama > Musical"
    },
    {
      label: "One-Act Plays",
      value: "Play or Drama > One-Act Play"
    },
    {
      label: "Verse Dramas",
      value: "Play or Drama > Verse Drama"
    },
    {
      label: "Other",
      value: "Play or Drama > <n/a>"
    }
  ],
  poetryGuideReference: [
    {
      label: "All Poetry Guides",
      value: "!Poetry Guide"
    },
    {
      label: "Titles",
      value: "Poetry Guide > Poetry Guide"
    },
    {
      label: "Themes",
      value: "Poetry Guide > Theme"
    },
    {
      label: "Symbols",
      value: "Poetry Guide > Symbol"
    },
    {
      label: "Poetic Devices",
      value: "Poetry Guide > Poetic Device"
    }
  ],
  poetryReference: [
    {
      label: "All Poetry",
      value: "!Poetry"
    },
    {
      label: "Lyric Poetry",
      value: "Poetry > Lyric Poetry"
    },
    {
      label: "Narrative Poetry",
      value: "Poetry > Narrative Poetry"
    },
    {
      label: "Other",
      value: "Poetry > <n/a>"
    }
  ],
  proseFictionReference: [
    {
      label: "All Prose Fiction",
      value: "!Prose Fiction"
    },
    {
      label: "Folktales, Fables, or Fairy Tales",
      value: "Prose Fiction > Folktale, Fable, or Fairy Tale"
    },
    {
      label: "Graphic Novels",
      value: "Prose Fiction > Graphic Novel"
    },
    {
      label: "Novels",
      value: "Prose Fiction > Novel"
    },
    {
      label: "Novellas",
      value: "Prose Fiction > Novella"
    },
    {
      label: "Short Stories/Story Collections",
      value: "Prose Fiction > Short Story / Story Collection"
    },
    {
      label: "Other",
      value: "Prose Fiction > <n/a>"
    }
  ],
  proseNonfictionReference: [
    {
      label: "All Prose Nonfiction",
      value: "!Prose Nonfiction"
    },
    {
      label: "Autobiographies/Memoirs",
      value: "Prose Nonfiction > Autobiography / Memoir"
    },
    {
      label: "Biographies",
      value: "Prose Nonfiction > Biography"
    },
    {
      label: "Diaries or Journals",
      value: "Prose Nonfiction > Diary or Journal"
    },
    {
      label: "Documents",
      value: "Prose Nonfiction > Document"
    },
    {
      label: "Essays",
      value: "Prose Nonfiction > Essay"
    },
    {
      label: "Graphic Memoirs/Biographies",
      value: "Prose Nonfiction > Graphic Memoir / Biography"
    },
    {
      label: "History",
      value: "Prose Nonfiction > History"
    },
    {
      label: "Philosophy & Political Philosophy",
      value: "Prose Nonfiction > Philosophy & Political Philosophy"
    },
    {
      label: "Sermons, Speeches, or Lectures",
      value: "Prose Nonfiction > Sermon, Speech, or Lecture"
    },
    {
      label: "Sociology & Social Science",
      value: "Prose Nonfiction > Sociology & Social Science"
    },
    {
      label: "Theology",
      value: "Prose Nonfiction > Theology"
    },
    {
      label: "Other",
      value: "Prose Nonfiction > <n/a>"
    }
  ],
  referenceMapping: {
    "Lit Guide": "litGuideReference",
    "Lit Term": "litTermReference",
    Mythology: "mythologyReference",
    "Play or Drama": "playDramaReference",
    Poetry: "poetryReference",
    "Poetry Guide": "poetryGuideReference",
    "Prose Fiction": "proseFictionReference",
    "Prose Nonfiction": "proseNonfictionReference",
    Shakescleare: "shakesReference"
  },
  shakesReference: [
    {
      label: "All Shakescleare",
      value: "!Shakescleare"
    },
    {
      label: "Titles",
      value: "Shakescleare > Shakescleare"
    },
    {
      label: "Scenes",
      value: "Shakescleare > Scene"
    }
  ]
};
